import { NotifyErrorWrapper } from '@/helpers/core/notifications'
import { bulkDeleteMiners, createMiner, deleteMiner, updateMinerParts } from '@/services/rc.service'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

/**
 * Composable for miner CRUD operations
 * @returns Object containing mutations for miner operations
 */
export const useMiners = () => {
  const client = useQueryClient()

  /**
   * Mutation for creating a new miner
   */
  const createMinerMutation = useMutation({
    mutationKey: ['create-miner'],
    mutationFn: createMiner,
    onError: NotifyErrorWrapper('Failed to add miner'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['container-miners'] })
    },
  })

  /**
   * Mutation for deleting a miner
   */
  const deleteMinerMutation = useMutation({
    mutationKey: ['delete-miner'],
    mutationFn: deleteMiner,
    onError: NotifyErrorWrapper('Failed to delete miner'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['container-miners'] })
    },
  })

  /**
   * Mutation for bulk deleting miners
   */
  const bulkDeleteMinersMutation = useMutation({
    mutationKey: ['bulk-delete-miners'],
    mutationFn: bulkDeleteMiners,
    onError: NotifyErrorWrapper('Failed to delete miners'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['container-miners'] })
    },
  })
  /**
   * Mutation for updating a miner's parts/details
   */
  const updateMinerMutation = useMutation({
    mutationKey: ['update-miner'],
    mutationFn: updateMinerParts,
    onError: NotifyErrorWrapper('Failed to update miner'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['container-miners'] })
    },
  })

  return {
    createMinerMutation,
    deleteMinerMutation,
    bulkDeleteMinersMutation,
    updateMinerMutation,
  }
}
